import * as Yup from "yup";
import "yup-phone";

export const ChangePasswordSchema = Yup.object({
  oldPassword: Yup.string().required("Old password cannot be blank"),
  newPassword: Yup.string()
  .min(8,"New password should contain 8 character")
  .matches(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/, "New Password must contain at least one upper case, one lower case, one special character.")
  .required("New password cannot be blank"),
  confirmNewPassword: Yup.string().required("Confirm New password cannot be blank").when("newPassword", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: Yup.string().oneOf(
      [Yup.ref("newPassword")],
      "Password doesn't match"
    ),
  }),
});
